import Button from "components/Buttons";
import { useBrandDisciplineStore } from "stores/brandDiscipline/useBrandDisciplineStore";
import { useCartActions } from "../utils";
import { useCartStore } from "stores/cart/useCartStore";

export const ActionButtons = ({ 
  user, 
  filteredSaddle, 
  selectedHorse, 
  locationState,
  selectedHorseStatus,
  handleCheckAuth,
  isMobile = false 
}) => {
  const { handleAddToCart, onBuyNowHandler, addToCartLoading, checkoutLoading, open } = useCartActions();
  const changeActionState = useBrandDisciplineStore(action => action.changeActionState);
  const userCartData = useCartStore((s) => s.userCartData);
  const handleRemove = useCartStore((s) => s.handleRemove);
  const removeCartLoading = useCartStore((s) => s.loadingState?.removeCartLoading);
  const loadingItemId = useCartStore((s) => s.loadingItemId);
  const isAnyInCart = (userCartData?.items?.length || 0) > 0;
  const currentSk = filteredSaddle?.saddle?.sk || filteredSaddle?.sk || locationState?.item?.sk;
  const isCurrentInCart = userCartData?.items?.some(
    (ci) => (ci?.productData?.sk || ci?.saddleId || ci?.id) === currentSk
  );
  // Block purchase until the dropdowns resolve to a real VARIANT. When size (or
  // color, when applicable) isn't picked, filteredSaddle falls back to the
  // PRODUCT row, which isn't purchasable.
  const variantNotSelected = filteredSaddle?.type !== "VARIANT";
  const selectVariantHint = variantNotSelected
    ? "Select a size and color to continue"
    : undefined;
  return (
    <div className={isMobile ? "flex w-full justify-between  sm:justify-end items-center sm:flex-row mt-[20px]" : "flex gap-x-[10px]"}>
      {(() => {
        const sk = filteredSaddle?.saddle?.sk || filteredSaddle?.sk;
        const isInCart = userCartData?.items?.some(
          (ci) => (ci?.productData?.sk || ci?.saddleId || ci?.id) === sk
        );
        const isAnyInCart = (userCartData?.items?.length || 0) > 0;
        if (isInCart) {
          return (
            <Button
              onClick={() => handleRemove(sk)}
              className={isMobile ? "addToCart_btn_mobile !w-[240px]  !bg-[#C8403B]" : "addToCart_btn !w-auto px-3 !bg-[#C8403B]"}
              whiteOutline
              loading={removeCartLoading && loadingItemId === sk}
              disabled={!user || selectedHorseStatus === "PENDING"}
            >
              Remove from Cart
            </Button>
          );
        }
        return (
          <Button
            onClick={() => {
              if (user) {
                handleAddToCart(filteredSaddle, selectedHorse, changeActionState, open);
              } else {
                handleCheckAuth();
              }
            }}
            className={isMobile ? "addToCart_btn_mobile" : "addToCart_btn"}
            primary
            whiteOutline
            loading={addToCartLoading === filteredSaddle?.saddle?.sk}
            disabled={!user || addToCartLoading || selectedHorseStatus === "PENDING" || isAnyInCart || variantNotSelected}
            title={selectVariantHint}
          >
            Add to Cart
          </Button>
        );
      })()}
      <Button
        className={isMobile ? "buynow_btn_mobile sm:mt-0" : "buynow_btn"}
        disabled={!user || selectedHorseStatus === "PENDING" || (isAnyInCart && !isCurrentInCart) || variantNotSelected}
        title={selectVariantHint}
        onClick={() => {
          if (user) {
            // Use the selected variant's sk, not the originally-loaded saddle's.
            // Otherwise changing size/color in the dropdowns is silently ignored.
            onBuyNowHandler(filteredSaddle?.sk, filteredSaddle?.brandName);
          } else {
            handleCheckAuth();
          }
        }}
        loading={checkoutLoading}
      >
        Buy now
      </Button>
    </div>
  );
};
